import PropTypes from 'prop-types';
import { Component } from 'react';

class FloatingNotification extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		if (this.props.autoHide) {
			setTimeout(() => this.props.onHideFunc(), this.props.autoHideTime);
		}
	}

	render() {
		if (!this.props.notification.unread) {
			return null;
		}

		return (
			<div className={'floating-notification'} id={this.props.notification.id} onClick={this.props.onHideFunc}>
				<div className={'floating-notification-icon-container'}>
					<img className="floating-notification-icon" src={this.props.notification.iconUrl} />
				</div>
				<div className={'floating-notification-text-container'}>
					<span className={'floating-notification-headline'}>{this.props.notification.subject}</span>
					<span className={'floating-notification-text'}>{this.props.notification.text}</span>
					<a className={'floating-notification-link'} href={this.props.notification.target.link}>
						{this.props.notification.target.text}
					</a>
				</div>
			</div>
		);
	}
}

FloatingNotification.propTypes = {
	notification: PropTypes.object.isRequired,
	autoHide: PropTypes.bool,
	autoHideTime: PropTypes.number,
	onHideFunc: PropTypes.func.isRequired,
};

FloatingNotification.defaultProps = {
	autoHide: false,
};

export default FloatingNotification;
